export var STORAGE;
(function (STORAGE) {
    STORAGE[STORAGE["local"] = 0] = "local";
    STORAGE[STORAGE["session"] = 1] = "session";
})(STORAGE || (STORAGE = {}));
//# sourceMappingURL=storage.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-webstorage/dist/enums/storage.js
// module id = ../../../../ngx-webstorage/dist/enums/storage.js
// module chunks = 18